<div class="shipping-stop">
  <div class="shipping-stop__icon" [class.--is-finalized]="stop.finalized">
    <span>{{ stop.index + 1 }}</span>
  </div>
  <div class="shipping-stop__content">
    <h3 class="shipping-stop__content__title">
      <span class="pds-icon">{{ stop | shippingStopKind : 'icon' }}</span>
      <span>{{ stop | shippingStopKind : 'literal' }}</span>
    </h3>
    <address class="shipping-stop__content__address">{{ stop.address }}</address>
    <ul class="shipping-stop__content__description">
      @for (order of stop.commerceReferences; track $index) {
      <li>{{ order }}</li>
      }
    </ul>
    @if (stop.finalized && (proofUrl || stop.receiverName)) {
    <div class="shipping-stop__content__proof">
      @if (proofUrl) {
      <img class="shipping-stop__content__proof__photo" [src]="proofUrl" alt="Foto do comprovante" loading="lazy" />
      }
      @if (stop.receiverName) {
      <p class="shipping-stop__content__proof__receiver">Recebido por {{ stop.receiverName }}</p>
      }
    </div>
    }
    @if(!stop.finalized) {
    <div class="shipping-stop__content__actions">
      <button class="ds-button --is-secondary --has-icon --is-small" (click)="onClickCheckStop()">
        <span class="shipping-stop__content__actions__action pds-icon">task_alt</span>
        <span class="shipping-stop__content__actions__action__label">concluir {{ stop | shippingStopKind : 'literal' }}</span>
      </button>

      <button class="ds-button --is-default --has-icon --is-small --is-square" (click)="onClickDetails()">
        <span class="shipping-stop__content__actions__action pds-icon">visibility</span>
      </button>
    </div>
    }
  </div>
</div>

<peca-dialog #dialog>
  <dl class="shipping-stop-dialog">
    <div>
      <dt>Tipo</dt>
      <dd>{{ stop | shippingStopKind : 'literal' }}</dd>
    </div>

    <div>
      <dt>Endereço</dt>
      <dd>{{ stop.address }}</dd>
    </div>

    <div>
      <dt>Pedidos</dt>
      <ul>
        @for (order of stop.commerceReferences; track $index) {
        <li>{{ order }}</li>
        }
      </ul>
    </div>

    <div>
      <dt>Contato</dt>
      <dd>
        <div>{{ stop.name }}</div>
        <div>{{ stop.phone }}</div>
      </dd>
    </div>
    @if (stop.finalized) {
    <div>
      <dt>Comprovante</dt>
      <dd>
        @if (proofUrl) {
        <img class="shipping-stop-dialog__proof-photo" [src]="proofUrl" alt="Foto do comprovante" loading="lazy" />
        }
        @if (stop.receiverName) {
        <div>Recebido por {{ stop.receiverName }}</div>
        }
      </dd>
    </div>
    } @else {
    <div>
      <dt>Foto do comprovante</dt>
      <dd>
        <label class="ds-button --is-default --has-icon" for="proof-photo-{{ stop.index }}">
          <span class="pds-icon">add_a_photo</span>
          <span class="action-btn__label">{{ selectedPhoto ? 'trocar foto' : 'tirar foto / enviar' }}</span>
        </label>
        <input
          id="proof-photo-{{ stop.index }}"
          type="file"
          accept=".jpg,.jpeg,.png,image/jpeg,image/png"
          capture="environment"
          hidden
          (change)="onFileSelected($event)"
        />
        @if (previewUrl) {
        <img class="shipping-stop-dialog__proof-photo" [src]="previewUrl" alt="Prévia do comprovante" />
        }
        @if (photoError) {
        <p class="shipping-stop-dialog__error">{{ photoError }}</p>
        }
      </dd>
    </div>
    @if (isDropoff) {
    <div>
      <dt><label class="shipping-stop-dialog__label" for="receiver-name-{{ stop.index }}">Nome de quem recebeu</label></dt>
      <dd>
        <input
          id="receiver-name-{{ stop.index }}"
          class="ds-input"
          [class.--has-error]="receiverError"
          type="text"
          [(ngModel)]="receiverName"
          placeholder="Ex.: Maria Silva"
          autocomplete="off"
          maxlength="120"
        />
        @if (receiverError) {
        <p class="shipping-stop-dialog__error">{{ receiverError }}</p>
        }
      </dd>
    </div>
    }
    }
    @if(!stop.finalized) {
    <div class="shipping-stop-dialog__actions">
      <a class="ds-button --is-default --has-icon" [href]="stop.address | linkToMap" target="_blank" (click)="onClickOpenAtMap()">
        <span class="pds-icon">map</span>
        <span class="action-btn__label">ver no mapa</span>
      </a>
      <button class="ds-button --is-default --has-icon" (click)="copyAddress(stop.address)">
        <span class="pds-icon">content_copy</span>
        <span class="action-btn__label">copiar endereço</span>
      </button>
      <button class="ds-button --is-default --has-icon --is-secondary" (click)="onSubmitProof()" [disabled]="submitting">
        <span class="pds-icon">task_alt</span>
        <span class="action-btn__label">{{ submitting ? 'enviando foto...' : ('finalizar ' + (stop | shippingStopKind : 'literal' | lowercase)) }}</span>
      </button>
    </div>
    }
  </dl>
</peca-dialog>
